import styled from "styled-components";

export const CurriculumSubTitleText = styled.h2`
  font-size: 2.875rem;
  color: #ffffff;
  text-align: center;
`;
